import { useContext } from 'react';
import { ShiftHistoryContext } from 'contexts/shift_history_context';

const useShiftHistory = () => {
    return useContext(ShiftHistoryContext);
};

export default useShiftHistory;
